import { action, computed, makeObservable, observable } from 'mobx';
import { JobCategory } from 'jobs/types';
import { MultiSelectViewModel } from 'shared/components';

export class SpecialityViewModel {
   readonly multiselect: MultiSelectViewModel<JobCategory>;
   readonly subCategories = observable.array<JobCategory>([]);
   query: string = '';

   constructor(options: { onValueChange?: (values: JobCategory[]) => void } = {}) {
      makeObservable(this, {
         results: computed,
         set: action,
      });

      this.multiselect = new MultiSelectViewModel<JobCategory>([], {
         maxSelected: 2,
         getLabel: (value) => {
            return value.name;
         },
         onValueChange: options.onValueChange,
      });
   }

   onValueChange = (v: JobCategory[]) => void {};

   set(categories: JobCategory[]): void {
      this.multiselect.clearValues();
      this.subCategories.replace(categories);
   }

   get results(): JobCategory[] {
      return this.subCategories.filter((cat) =>
         cat.name.toLowerCase().includes(this.multiselect.search)
      );
   }

   clear(): void {
      this.query = '';
   }
}
